interface CurrencyInfo {
  locale: string;
  decimals: number;
}

interface CurrencyLocaleMap {
  [currencyCode: string]: CurrencyInfo;
}

const currencyLocaleMap: CurrencyLocaleMap = {
  USD: { locale: 'en-US', decimals: 2 },
  EUR: { locale: 'en-GB', decimals: 2 },
  JPY: { locale: 'ja-JP', decimals: 0 },
  GBP: { locale: 'en-GB', decimals: 2 },
  SGD: { locale: 'en-SG', decimals: 2 },
  PHP: { locale: 'fil-PH', decimals: 2 },
  THB: { locale: 'th-TH', decimals: 2 },
  IDR: { locale: 'id-ID', decimals: 0 },
  AUD: { locale: 'en-AU', decimals: 2 },
  NZD: { locale: 'en-NZ', decimals: 2 },
  MYR: { locale: 'ms-MY', decimals: 2 },
  HKD: { locale: 'zh-HK', decimals: 2 },
  KRW: { locale: 'ko-KR', decimals: 0 },
  TWD: { locale: 'zh-TW', decimals: 2 },
  CNY: { locale: 'zh-CN', decimals: 2 },
  AED: { locale: 'ar-AE', decimals: 2 },
  SAR: { locale: 'ar-SA', decimals: 2 },
  QAR: { locale: 'ar-QA', decimals: 2 },
  OMR: { locale: 'ar-OM', decimals: 3 },
  KWD: { locale: 'ar-KW', decimals: 3 },
  BHD: { locale: 'ar-BH', decimals: 3 },
  JOD: { locale: 'ar-JO', decimals: 3 },
  IQD: { locale: 'ar-IQ', decimals: 3 },
};

const defaultCurrencyInfo: CurrencyInfo = {
  locale: 'en-US',
  decimals: 2,
};

const currencyFormatters: Record<string, Intl.NumberFormat> = {};

export const getCurrencyFormatter = (currencyCode: string): Intl.NumberFormat | null => {
  if (currencyFormatters[currencyCode]) {
    return currencyFormatters[currencyCode];
  }

  const currencyInfo = currencyLocaleMap[currencyCode] || defaultCurrencyInfo;
  const { locale, decimals } = currencyInfo;

  if (!locale || !decimals) {
    return null;
  }

  try {
    currencyFormatters[currencyCode] = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: decimals,
    });
  } catch (error) {
    console.debug(`Failed to create currency formatter for code: ${currencyCode}`, error);
    return null;
  }

  return currencyFormatters[currencyCode] || null;
};
